import React from 'react';
import { useNavigate } from 'react-router-dom';
import './foodToAvoid.css';
import pawImg from '../assets/paw.png';
import buttonStyles from '../components/Buttons.module.css';

const HowRecipesAreDeveloped: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="page-container cream-bg">
      {/* Floating Paw Print Background */}
      <div className="hero-paw-bg">
        <img src={pawImg} className="hero-paw-float paw1" alt="" />
        <img src={pawImg} className="hero-paw-float paw2" alt="" />
        <img src={pawImg} className="hero-paw-float paw3" alt="" />
        <img src={pawImg} className="hero-paw-float paw4" alt="" />
        <img src={pawImg} className="hero-paw-float paw5" alt="" />
        <img src={pawImg} className="hero-paw-float paw6" alt="" />
        <img src={pawImg} className="hero-paw-float paw7" alt="" />
      </div>

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '2rem 2rem 0' }}>
        <button
          className={`${buttonStyles.antBtn} ${buttonStyles.antBtnSecondary}`}
          style={{ fontSize: '1.08rem', padding: '0.7em 1.6em', borderRadius: '14px', fontWeight: 600 }}
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          ← Back
        </button>
      </div>

      <div className="page-intro">
        <h1 className="page-title">How Our Recipes Are Developed</h1>
        <div className="page-intro-underline" />
      </div>

      <div className="content-section" style={{ margin: '0 auto', padding: '0 1.5rem 3rem 1.5rem' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: '2rem 2.5rem', boxShadow: '0 4px 12px rgba(44,62,80,0.08)', lineHeight: 1.8 }}>
          
          <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', color: '#555' }}>
            Homemade dog food can be a healthy option when recipes are carefully balanced. Each recipe in this app is designed using established canine nutrition guidelines, whole-food nutrient sources, and common veterinary nutrition recommendations.
          </p>

          <p style={{ fontSize: '1.05rem', marginBottom: '2.5rem', color: '#555', fontStyle: 'italic' }}>
            Our goal is to make homemade feeding simple, practical, and nutritionally responsible.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2rem', marginBottom: '1rem', fontWeight: 700 }}>Nutritional Principles Used</h2>
          
          <p style={{ marginBottom: '2rem', color: '#555' }}>
            When developing recipes, we focus on providing the key nutrients dogs require for maintenance and overall health.
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '2rem', marginBottom: '0.8rem', fontWeight: 600 }}>Protein</h3>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Protein supports muscle maintenance, immune function, and overall body health.
          </p>

          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Recipes use high-quality animal proteins such as:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem', color: '#555' }}>
            <li>chicken</li>
            <li>turkey</li>
            <li>beef</li>
            <li>lamb</li>
            <li>fish</li>
            <li>eggs</li>
          </ul>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            These provide essential amino acids dogs need.
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '2rem', marginBottom: '0.8rem', fontWeight: 600 }}>Calcium and Phosphorus Balance</h3>
          
          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Dogs require proper calcium levels to support:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>bone health</li>
            <li>nerve function</li>
            <li>muscle function</li>
          </ul>

          <p style={{ marginBottom: '0.5rem', color: '#555' }}>
            Because boneless meats contain phosphorus but little calcium, recipes include a calcium source such as:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '2rem', color: '#555' }}>
            <li>finely ground eggshell powder</li>
          </ul>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            This helps maintain an appropriate calcium-to-phosphorus ratio.
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '2rem', marginBottom: '0.8rem', fontWeight: 600 }}>Omega-3 Fatty Acids</h3>
          
          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Omega-3 fats support:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>skin and coat health</li>
            <li>brain function</li>
            <li>inflammation regulation</li>
          </ul>

          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Recipes include sources such as:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '2rem', color: '#555' }}>
            <li>fish oil</li>
            <li>sardine oil</li>
            <li>oily fish</li>
          </ul>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '2rem', marginBottom: '0.8rem', fontWeight: 600 }}>Essential Minerals</h3>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Dogs require small amounts of trace minerals for healthy metabolism.
          </p>

          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Recipes include whole-food sources such as:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>pumpkin seeds (manganese and zinc)</li>
            <li>iodized salt (iodine)</li>
          </ul>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            These help provide micronutrients needed for normal body functions.
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '2rem', marginBottom: '0.8rem', fontWeight: 600 }}>Healthy Fats</h3>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Fats provide energy and support vitamin absorption.
          </p>

          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Recipes include sources such as:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>sunflower oil</li>
            <li>poultry fat</li>
            <li>fish oil</li>
          </ul>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            These also contribute vitamin E and essential fatty acids.
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '2rem', marginBottom: '0.8rem', fontWeight: 600 }}>Fiber and Digestibility</h3>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Vegetables provide fiber and nutrients that support digestion.
          </p>

          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Common ingredients include:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>pumpkin</li>
            <li>zucchini</li>
            <li>carrots</li>
            <li>green beans</li>
            <li>leafy greens</li>
          </ul>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            These help support normal digestion and stool quality.
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '2rem', marginBottom: '0.8rem', fontWeight: 600 }}>Whole-Food First Approach</h3>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Whenever possible, nutrients are provided through whole foods rather than isolated supplements.
          </p>

          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>Whole-food sources are used for nutrients such as:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>manganese</li>
            <li>zinc</li>
            <li>vitamin E</li>
            <li>iodine</li>
          </ul>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            Optional ingredients such as nutritional yeast may also be included for additional nutrients and flavor.
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '2rem', marginBottom: '0.8rem', fontWeight: 600 }}>Portion and Batch Scaling</h3>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Recipes are designed to scale based on batch size. Supplement amounts are adjusted relative to the total batch weight to maintain balanced proportions.
          </p>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            This helps ensure that nutrients remain consistent whether preparing small or large batches.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Sources and References</h2>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Recipe development was informed by widely accepted canine nutrition resources, including:
          </p>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontWeight: 600 }}>Veterinary Nutrition Guidelines</h3>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem', color: '#555' }}>
            <li>National Research Council (NRC). <em>Nutrient Requirements of Dogs and Cats</em>.</li>
            <li>Association of American Feed Control Officials (AAFCO) nutrient profiles for dogs.</li>
          </ul>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontWeight: 600 }}>Veterinary Nutrition Resources</h3>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem', color: '#555' }}>
            <li>Tufts University Cummings Veterinary Medical Center – Petfoodology</li>
            <li>BalanceIT veterinary nutrition resources</li>
            <li>American College of Veterinary Nutrition (ACVN)</li>
          </ul>

          <h3 style={{ color: '#c14444', fontSize: '1.3rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontWeight: 600 }}>Ingredient Nutrient Data</h3>
          <ul style={{ marginLeft: '2rem', marginBottom: '2rem', color: '#555' }}>
            <li>USDA FoodData Central nutrient database</li>
            <li>Published veterinary nutrition references</li>
          </ul>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            These resources provide the nutritional science used when evaluating ingredients and nutrient needs.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Important Note</h2>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Every dog is different. Factors such as:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>age</li>
            <li>breed</li>
            <li>activity level</li>
            <li>medical conditions</li>
          </ul>
          <p style={{ marginBottom: '2rem', color: '#555' }}>
            can affect dietary needs.
          </p>

          <p style={{ marginBottom: '2rem', color: '#555', fontWeight: 600, background: '#fffbe6', padding: '1rem 1.5rem', borderRadius: 8, borderLeft: '4px solid #c14444' }}>
            These recipes are designed for generally healthy adult dogs. Dogs with medical conditions may require individualized diets recommended by a veterinarian or veterinary nutritionist.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Our Goal</h2>
          
          <p style={{ marginBottom: '0.5rem', color: '#555' }}>
            This project was created to help make homemade feeding:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1rem', color: '#555' }}>
            <li>easier</li>
            <li>more accessible</li>
            <li>more thoughtfully balanced</li>
          </ul>
          <p style={{ color: '#555' }}>
            while still keeping recipes practical for everyday home cooks.
          </p>

        </div>
      </div>
    </div>
  );
};

export default HowRecipesAreDeveloped;
